import { render } from "./what-group-message.vue?vue&type=template&id=7535f94b&lang=pug"
import script from "./what-group-message.vue?vue&type=script&lang=js"
export * from "./what-group-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__